import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ThreeBounce } from 'better-react-spinkit';
import { doGET } from '../../../util/HttpUtil';
import ApplyBusinessPrime from './BPrime/ApplyBusinessPrime';
import ApplyBusinessLite from './BusinessLiteForms/ApplyBusinessLite';
import ApplyBusinessV2 from './BusinessV2/ApplyBusinessV2';

const RESOLVED_FLOW = {
    LOADING: 'loading',
    LEGACY_PLUS: 'legacy_plus',
    LEGACY_PRIME: 'legacy_prime',
    V2: 'v2',
};

const resolveFlowFromApplication = (applicationForm = {}) => {
    if (applicationForm?.formType === 'BUSINESS' && applicationForm?.type != null) {
        return RESOLVED_FLOW.V2;
    }

    if (applicationForm?.formType === 'BUSINESS_PRIME') {
        return RESOLVED_FLOW.LEGACY_PRIME;
    }

    return RESOLVED_FLOW.LEGACY_PLUS;
};

const withNoCacheParam = (url) => {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}_ts=${Date.now()}`;
};

const BusinessApplicationEntry = () => {
    const { edit_id } = useParams();
    const [resolvedFlow, setResolvedFlow] = useState(RESOLVED_FLOW.LOADING);

    useEffect(() => {
        let mounted = true;
        setResolvedFlow(RESOLVED_FLOW.LOADING);

        const resolveFlow = async () => {
            try {
                const applicationResponse = await doGET(
                    withNoCacheParam(`/api/application-form/detail?id=${edit_id}&withExtension=true`)
                );
                if (!mounted) {
                    return;
                }

                const applicationForm = applicationResponse?.data || {};
                setResolvedFlow(resolveFlowFromApplication(applicationForm));
            } catch (applicationError) {
                try {
                    const primeResponse = await doGET(
                        withNoCacheParam(`/api/business-prime/detail?id=${edit_id}`)
                    );
                    if (!mounted) {
                        return;
                    }

                    if (primeResponse?.status === 200 && primeResponse?.data?._id) {
                        setResolvedFlow(RESOLVED_FLOW.LEGACY_PRIME);
                        return;
                    }
                } catch (primeError) {
                    console.error('BusinessApplicationEntry business-prime fallback failed:', primeError);
                }

                try {
                    const businessResponse = await doGET(
                        withNoCacheParam(`/api/business/detail?id=${edit_id}`)
                    );
                    if (!mounted) {
                        return;
                    }

                    if (businessResponse?.data?.type != null) {
                        setResolvedFlow(RESOLVED_FLOW.V2);
                        return;
                    }
                } catch (businessError) {
                    console.error('BusinessApplicationEntry business fallback failed:', businessError);
                }

                if (mounted) {
                    setResolvedFlow(RESOLVED_FLOW.LEGACY_PLUS);
                }
            }
        };

        resolveFlow();

        return () => {
            mounted = false;
        };
    }, [edit_id]);

    if (resolvedFlow === RESOLVED_FLOW.LOADING) {
        return (
            <div className="d-flex justify-content-center align-items-center py-5">
                <ThreeBounce color="#0B72B9" size={16} />
            </div>
        );
    }

    if (resolvedFlow === RESOLVED_FLOW.V2) {
        return <ApplyBusinessV2 key={edit_id} />;
    }

    if (resolvedFlow === RESOLVED_FLOW.LEGACY_PRIME) {
        return <ApplyBusinessPrime key={edit_id} />;
    }

    return <ApplyBusinessLite key={edit_id} />;
};

export default BusinessApplicationEntry;
